<template>
  <v-container text-xs-center>
    <div id="app">
      <BaseTable :tableHeaders="headers" :tableItems="clubs" :tableLoading="loadingTable" :tableSearch="search">
        <template v-slot:table-top>
          <BaseToolbar toolbarTitle="Clubs">
            <template v-slot:toolbarSearch>
              <v-text-field v-model="search" append-icon="search" label="Search Club" single-line
                hide-details></v-text-field>
            </template>
            <template v-slot:toolbarBtn>
              <v-dialog v-model="dialog" :retain-focus="false" max-width="700px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark v-on="on">{{ formTitle }}</v-btn>
                </template>
              </v-dialog>
            </template>
          </BaseToolbar>
        </template>
        <template v-slot:[`table-actions`]="{ actionItem }">
          <v-icon small class="mr-2" @click="editItem(actionItem.node)">
            edit
          </v-icon>
          <v-icon small @click="deleteClub(Number(actionItem.node.clubId))">
            delete
          </v-icon>
        </template>
        <!-- <template #[`item.node.groups`]="{ item }">
          <td>{{ item.node.team.edges.length }}</td>
        </template> -->
      </BaseTable>
      <!--Add new club dialog-->
      <v-dialog v-model="dialog" :retain-focus="false" max-width="500px" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.clubCode" label="Club Code"
                    :rules="nameRules" :counter="6" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.clubName" label="Club Name"
                    :rules="nameRules" :counter="50" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.clubDesc" label="Club Desc"
                    :rules="nameRules" :counter="50"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.logo" label="Logo"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.email" label="Email"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.groups"
                    label="Number of groups"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.athletes"
                    label="Number of Athlete's"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.website" label="Website"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.reviewsUrl"
                    label="Reviews"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.facebookUrl"
                    label="Facebook"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.instagramUrl"
                    label="Instagram"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.xUrl" label="X"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.tiktokUrl" label="Tiktok"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.youtubeUrl"
                    label="YouTube"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined dense hide-details v-model="itemData.discordUrl"
                    label="Discord"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field dense type="number" :rules="latLngRules" v-model.number="itemData.latitude" outlined
                    label="Latitude"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field dense type="number" :rules="latLngRules" v-model.number="itemData.longitude" outlined
                    label="Longitude"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select outlined dense hide-details class="hidden-xs-only" v-model="itemData.countryId"
                    :items="countryList" label="Country" :rules="requiredRule" item-value="node.valId"
                    item-text="node.valDesc"></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                    offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field outlined dense hide-details v-model="itemData.year" label="Year"
                        prepend-inner-icon="event" v-on="on" v-bind="attrs" readonly no-title></v-text-field>
                    </template>
                    <v-date-picker ref="picker" v-model="itemData.createDate" :active-picker.sync="activePicker"
                      @click:year="setYear"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-switch color="secondary" v-model="itemData.visibility" label="Visibility"></v-switch>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <div class="rank_wrapper">
                    <v-checkbox label="ranksClasifications"></v-checkbox>
                    <v-select style="max-width: 250px" :items="ranksClasifications" item-text="node" item-value="node">
                    </v-select>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" text @click="close">Cancel</v-btn>
            <v-btn :disabled="!isFormValid" color="secondary" text @click="actionName">
              {{ editedIndex > 0 ? "Edit" : "Add" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>
<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import {
  defaultClubData,
  clubsTableHeaders,
  clubNameValidationRules,
  clubRequiredValidationRules,
  paginationSettings,
  regLatLngNumberValidationRule,
} from "../../../constants/clubs";
import BaseTable from "../../base/BaseTable.vue";
import BaseToolbar from "../../base/BaseToolbar.vue";

export default {
  components: { BaseToolbar, BaseTable },
  data() {
    return {
      loadingData: true, // Ensures data is properly loaded
      activePicker: null,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      loadingTable: true,
      isFormValid: true,
      search: "",
      on: "",
      dialog: false,
      menu: false,
      dateModel: true,
      editableId: 0,
      pagination: paginationSettings,
      nameRules: clubNameValidationRules,
      requiredRule: clubRequiredValidationRules,
      latLngRules: regLatLngNumberValidationRule,
      headers: clubsTableHeaders,
      editedIndex: -1,
      itemData: {
        clubCode: "",
        clubName: "",
        clubDesc: "",
        countryId: 0,
        logo: "",
        email: "",
        latitude: null,
        longitude: null,
        year: null,
        visibility: 0,
        createDate: "",
        athletes: "",
        groups: "",
        website: "",
        reviewsUrl: "",
        facebookUrl: "",
        instagramUrl: "",
        xUrl: "",
        tiktokUrl: "",
        youtubeUrl: "",
        discordUrl: "",
      },
      defaultItem: defaultClubData,
      ranks: [],
    };
  },
  created() {
    this.allClubs()
      .then(() => (this.loadingTable = false))
      .catch((error) => console.error(error));
  },
  computed: {
    ...mapGetters(["loading", "clubs", "categoryValue"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Club" : "Edit Club";
    },
    processedClubs() {
      return this.clubs.map(club => ({
        node: {
          ...club, // Keep all existing club properties
          groups: Array.isArray(club.groups) ? club.groups.length : 0, // 🔥 Ensure it's a number
          athletes: Array.isArray(club.groups)
            ? club.groups.reduce((sum, group) => sum + (Array.isArray(group.athletes) ? group.athletes.length : 0), 0)
            : 0
        }
      }));
    },
    ranksClasifications() {
      if (this.categoryValue.edges) {
        this.categoryValue.edges.filter((item) => {
          if (item.node.category.catName === "RANK_CLASS") {
            this.ranks.push({ node: item.node.valName, selected: false });
          }
        });
        return this.ranks;
      } else {
        return [];
      }
    },
    actionName() {
      return this.editedIndex > 0 ? this.editClubInfo : this.addNewClub;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    countryList() {
      if (this.categoryValue.edges) {
        return this.categoryValue.edges.filter(
          (category) => category.node.category.catName === "COUNTRY_LIST"
        );
      }
    },
    currentYear() {
      return this.itemData.year === null
        ? this.moment.format("YYYY-MM-DD")
        : this.itemData.year;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    clubs: {
      handler(newValue) {
        if (newValue && newValue.length) {
          this.loadingData = false; // Data is ready, stop loading
        } else {
          this.loadingData = true; // Keep loading if empty or undefined
        }
      },
      immediate: true, // Run immediately when component is mounted
    }
  },

  methods: {
    ...mapActions(["addClub", "allClubs", "clubDelete", "editClub"]),
    /**
     * @param {Int} id
     */
    editItem(item) {
      this.dialog = true;
      this.itemData = Object.assign({}, item);
      this.editedIndex = 1;
    },

    deleteClub(id) {
      this.loadingTable = true;
      confirm("Are you sure you want to delete this club?") &&
        this.clubDelete(id).then(() => {
          this.loadingTable = false;
          this.$toast.error("Club has been deleted");
        });
    },

    close() {
      this.dialog = false;
      this.itemData = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    addNewClub() {
      this.loadingTable = true;

      this.addClub({
        ...this.itemData,
        password: String("SportEcoSys123!"),
        createDate: String(
          this.itemData.createDate.length > 0
            ? this.itemData.createDate
            : this.moment.format("YYYY-MM-DD")
        ),
        year: Number(this.itemData.year),
        updateSource: "VueJS tst",
      }).then(() => {
        this.loadingTable = false;
        this.close();
        this.$toast.success("Club has been added");
      });
    },

    editClubInfo() {
      this.loadingTable = true;
      this.editClub({
        ...this.itemData,
        clubId: +this.itemData.clubId,
        password: String("SportEcoSys123!"),
        createDate: String(
          this.itemData.createDate.length > 0
            ? this.itemData.createDate
            : this.moment.format("YYYY-MM-DD")
        ),
        // year: Number(
        //   this.itemData.createDate.length > 0
        //     ? this.itemData.createDate.split("-")[0]
        //     : this.moment.format("YYYY-MM-DD").split("-")[0]
        // ),
        updateSource: "VueJS tst",
      }).then(() => {
        this.dialog = false;
        this.loadingTable = false;
        this.editableId = -1;
        this.itemData = Object.assign({}, this.defaultItem);
        this.$toast.info("Club has been edited");
      });
    },
    setYear(data) {
      this.itemData.year = data;
      this.itemData.createDate = moment(new Date(data, "0", "1")).format(
        "YYYY-MM-DD"
      );
      this.menu = false;
    },
  },
};
</script>
